module.exports = __webpack_public_path__ + "img/kv_fw4.2c636ea0.png";